<template>
    <!-- 积分管理 － 积分明细页面 -->
    <content-view>
        <div slot="header">
            <a-form :form="form" layout="inline" class="store-one-form">
                <a-form-item label="积分类型">
                    <a-select allowClear v-decorator="['type']">
                        <a-select-option value="1">积分获取</a-select-option>
                        <a-select-option value="2">积分消耗</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="渠道">
                    <a-select allowClear v-decorator="['source']">
                        <a-select-option value="1">餐饮消费</a-select-option>
                        <a-select-option value="2">商品消费</a-select-option>
                        <a-select-option value="3">餐饮抵扣</a-select-option>
                        <a-select-option value="4">购票消费</a-select-option>
                        <a-select-option value="5">购票抵扣</a-select-option>
                        <a-select-option value="6">商品抵扣</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="手机号">
                    <a-input placeholder="请输入" v-decorator="['appUserPhone']"></a-input>
                </a-form-item>
                <a-form-item label="会员名称">
                    <a-input placeholder="请输入" v-decorator="['appUsername']"></a-input>
                </a-form-item>
                <a-form-item class="wrap-header-button">
                    <a-button @click="search" class="mr8" type="primary">筛选</a-button>
                    <a-button @click="handleReset">重置</a-button>
                </a-form-item>
            </a-form>
        </div>
        <div class="wrap-container-in">
            <a-table bordered :dataSource="dataSource" :columns="columns" :pagination="pagination" @change="changePage" :rowKey="record => record.id">
                <span slot="key" slot-scope="a,b,index">{{index+1}}</span>
                <span slot="createTime" slot-scope="a,row">{{row.createTime.substr(0,10)}}</span>
            </a-table>
        </div>
    </content-view>
</template>

<script type="text/javascript">
export default {
  name: 'detail',
  components: {},
  props: {},
  data() {
    const columns = [
      {
        title: '序号',
        dataIndex: 'key',
        scopedSlots: { customRender: 'key' }
      },
      {
        title: '积分类型',
        dataIndex: 'typeName'
      },
      {
        title: '渠道',
        dataIndex: 'sourceName'
      },
      {
        title: '会员手机号',
        dataIndex: 'appUserPhone'
      },
      {
        title: '会员名称',
        dataIndex: 'appUsername'
      },
      {
        title: '参与时间',
        dataIndex: 'createTime',
        scopedSlots: { customRender: 'createTime' }
      },
      {
        title: '获取/消耗积分',
        dataIndex: 'num'
      },
      {
        title: '备注',
        dataIndex: 'remark'
      }
    ];
    return {
      options: [],
      columns,
      dataSource: [],
      pagination: {
        showTotal: total => `共 ${total} 条数据`,
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        current: 1,
        pageSize: 20
      }
    };
  },
  computed: {},
  methods: {
    handleReset() {
      this.form.resetFields();
    },
    search() {
        this.pagination.current = 1;
        this.getList();
    },
    changePage(page) {
        this.pagination.pageSize = page.pageSize
        this.pagination.current = page.current
        this.getList()
    },
    getList() {
      this.form.validateFields((err, values) => {
          if (err) return;
          this.$api.integral
            .recordList({
              body: Object.assign(values, {
                userId: id,
                pageNum: this.pagination.current,
                pageSize: this.pagination.pageSize
              })
            })
            .then(res => {
              this.pagination.total = res.total;
              this.dataSource = res.list;
            });
      });
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  created() {},
  mounted() {
    this.getList();
  }
};
</script>
<style lang="scss">
.wrap-container-in {
  background-color: #fff;
  padding: 24px 32px;
  border-radius: 2px;
}
</style>